// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hcQ8","type":"styles_type__16RpK","choices":"styles_choices__3cCfZ"};